import React, { Component } from "react";
// import CssBaseline from "@material-ui/core/CssBaseline";
// import FormControl from "@material-ui/core/FormControl";
// import Input from "@material-ui/core/Input";
// import { TextField } from "@material-ui/core";
// import InputLabel from "@material-ui/core/InputLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import AuthApi from "../Services/Authapi";
// import clsx from "clsx";
// import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import ls from "local-storage";
// import { Textbox } from "react-inputs-validation";
// import LoadderButton from "../Layouts/LoadderButton";
import swal from "sweetalert";
// import Grid from "@material-ui/core/Grid";
// import { Formik } from "formik";
import LoginForm from "../Layouts/Forms/AuthForms/LoginForm";
// import './login.css';
import "./login.css";
import {
  getLoginContentSettings,
  LOGIN_CONTENT_STORAGE_EVENT,
} from "../../utils/loginContentSettings";
import {
  persistStoredRole,
  persistStoredUser,
  getPrimaryRoleFromUser,
  syncRoleToggleEligibility,
  recordLoginSession,
  isLoginSessionExpired,
  clearClientAuthState,
} from "../../utils/authSession";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: false,
      password: false,
      loginContent: getLoginContentSettings(),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  refreshLoginContent = () => {
    this.setState({ loginContent: getLoginContentSettings() });
  };


  hasValidToken = (token) => {
    return Boolean(
      token &&
      token !== false &&
      token !== "false" &&
      token !== null &&
      token !== "null" &&
      token !== undefined &&
      token !== "undefined" &&
      String(token).trim() !== "" &&
      !isLoginSessionExpired()
    );
  };

  componentWillMount() {
    const token = ls.get("authToken");
    if (this.hasValidToken(token)) {
      this.props.history.push("/dashboard");
    } else if (token && token !== false && token !== "false") {
      clearClientAuthState();
    }
  }
  componentDidMount() {
    // Ensure any stale native localStorage tokens don't auto-redirect back
    try {
      const token = window.localStorage.getItem('authToken');
      if (!this.hasValidToken(token)) {
        clearClientAuthState();
      }
    } catch (e) {}
    sessionStorage.setItem('mySessionItem', 'someValue');
    window.addEventListener(LOGIN_CONTENT_STORAGE_EVENT, this.refreshLoginContent);

    AuthApi.getLoginContent()
      .then((response) => {
        if (response && response.status && response.data) {
          this.setState({
            loginContent: {
              title: response.data.title || "",
              title2: response.data.title2 || "",
              quotes: response.data.quotes || "",
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching login content:", error);
      });
  }

  componentWillUnmount() {
    window.removeEventListener(LOGIN_CONTENT_STORAGE_EVENT, this.refreshLoginContent);
  }
  componentWillReceiveProps(props) {
    const token = ls.get("authToken");
    if (this.hasValidToken(token)) {
      props.history.push("/dashboard");
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault(); 
  
    let formData = {
      email: this.state.email,
      password: this.state.password,
    };
  
    let checkLogin = await AuthApi.login(formData);
  
    if (checkLogin && checkLogin.access_token) {
      ls.set("authToken", checkLogin.access_token);
      try {
        window.localStorage.setItem("authToken", checkLogin.access_token);
      } catch (e) {}

      const userObj = checkLogin.user || checkLogin.data?.user || checkLogin.data;
      if (userObj && typeof userObj === "object") {
        ls.set("user", userObj);
        try {
          window.localStorage.setItem("user", JSON.stringify(userObj));
        } catch (e) {}
      }

      const resolvedRole =
        (Array.isArray(checkLogin.roles) && checkLogin.roles[0]) ||
        getPrimaryRoleFromUser(userObj) ||
        (Array.isArray(userObj?.roles) && userObj.roles[0]?.name) ||
        false;

      persistStoredRole(resolvedRole);
      persistStoredUser(userObj);
      syncRoleToggleEligibility({ user: userObj, role: resolvedRole });

      const fallbackPermissions = Array.isArray(userObj?.roles)
        ? userObj.roles.flatMap((role) =>
            Array.isArray(role?.permissions)
              ? role.permissions
                  .map((permission) => permission?.name)
                  .filter((pName) => typeof pName === "string" && pName.trim() !== "")
              : []
          )
        : [];
      const userAccessList =
        (Array.isArray(checkLogin.userAccess) && checkLogin.userAccess.length > 0)
          ? checkLogin.userAccess
          : fallbackPermissions;
      ls.set("userAccess", userAccessList);
      try {
        window.localStorage.setItem("userAccess", JSON.stringify(userAccessList));
      } catch (e) {}

      recordLoginSession();

      this.props.setAutUser({
        authUser: checkLogin.data || checkLogin.user,
        authToken: checkLogin.access_token,
        roles: resolvedRole,
        user: userObj || false,
      });
      window.location.href = "/dashboard";
    } else {
      let errorMessage = checkLogin || "Login failed. Please try again.";
      swal("Error", errorMessage, "error");
    }
  };
  

  render() {
    const { loginContent } = this.state;
    return (
      <main className="hrms-login-page">
        <section className="hrms-login-card">
          <div className="hrms-login-visual">
            <div className="hrms-login-visual__content">
              <h2>{loginContent.title}</h2>
              <p>{loginContent.title2}</p>
              {loginContent.quotes && (
                <p className="hrms-login-visual__quote">{loginContent.quotes}</p>
              )}
            </div>

            <span className="hrms-login-shape hrms-login-shape--circle" aria-hidden="true" />
            <span className="hrms-login-shape hrms-login-shape--bar-one" aria-hidden="true" />
            <span className="hrms-login-shape hrms-login-shape--bar-two" aria-hidden="true" />
            <span className="hrms-login-shape hrms-login-shape--bar-three" aria-hidden="true" />
            <span className="hrms-login-shape hrms-login-shape--bar-four" aria-hidden="true" />

            <span className="hrms-login-line hrms-login-line--one" aria-hidden="true" />
            <span className="hrms-login-line hrms-login-line--two" aria-hidden="true" />
            <span className="hrms-login-line hrms-login-line--three" aria-hidden="true" />
            <span className="hrms-login-line hrms-login-line--four" aria-hidden="true" />
          </div>

          <div className="hrms-login-panel">
            <div className="hrms-login-panel__inner">
              <h1 className="hrms-login-panel__title">USER LOGIN</h1>
              <LoginForm setAutUser={this.props.setAutUser} />
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const styles = (theme) => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    overflow: "hidden",
    marginLeft: theme.spacing(40),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3, 2))]: {
      width: 400,
      // marginLeft: 'auto',
      // marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(10),
    // marginRight: 20,
    width: 710,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(10)}px ${theme.spacing(10)}px ${theme.spacing(
      10
    )}px`,
  },

  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(0),
  },
  submit: {
    marginTop: theme.spacing(3),
    backgroundColor: "#000",
  },
  link: {
    marginTop: theme.spacing(2),
  },
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});
export default withStyles(styles)(Login);






